import { StyledSvg } from "baseui/icon";
import React from "react";

export const EditIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg viewBox="0 0 16 16" {...props}>
    <path d="M12.175 1.6c-.273 0-.546.104-.754.313L10.133 3.2 12.8 5.867l1.287-1.288a1.067 1.067 0 000-1.508L12.93 1.913a1.064 1.064 0 00-.754-.313zM9.067 4.267l-6.262 6.261s.49-.044.672.139c.182.182.032 1.376.256 1.6.224.224 1.41.066 1.58.236.17.17.159.692.159.692l6.261-6.262-2.666-2.666zm-6.934 8l-.503 1.425a.533.533 0 00.678.678l.006-.002.013-.004.003-.002 1.403-.495-.8-.8-.8-.8z" />
  </StyledSvg>
);
